import React, { useCallback, useState } from 'react';
import { Box } from '@biome-design-system/ui/Box';
import { getRelativeParameterizedBookingUrl } from 'Src/utils/getRelativeParameterizedBookingUrl';
import {
  MapProviderCardListSheetContent,
  StyledMapProviderCardList,
  StyledSwipeableDrawer
} from 'Src/map-search-v9/components/SmallMediumView/styles';
import DashIcon from '@kyruus/react-ikons/Remove';
import {
  PROVIDER_CARD_OPEN,
  RENDER_PROVIDERS
} from 'Src/machines/map-search-v9/map-search-states';
import { getProviderUrl } from 'Src/provider/utils';

export function SwipeableProviderCardList({
  config,
  location,
  searchSummary,
  state,
  handleClose,
  onOpen,
  log,
  match
}) {
  const [swipeableDrawerOpen, setSwipeableDrawerOpen] = useState(false);
  const { selectedLocation, providers } = state.context;

  const onBookAppointment = useCallback(() => {
    if (log) {
      log(
        'user_action.search_page.map.provider_card.book_appointment_button_click'
      );
    }
  }, [log]);

  const onViewProvider = useCallback(() => {
    log('user_action.search_page.map.provider_card.view_profile_click');
  }, [log]);

  if (!state.matches(`${PROVIDER_CARD_OPEN}.${RENDER_PROVIDERS}`)) {
    return <></>;
  }

  const getProvidersForLocation = (providersList, locationId) => {
    if (!providersList || !locationId) return [];

    return providersList
      .filter(
        (provider) =>
          provider &&
          provider.locations &&
          provider.locations.some(
            (locationNew) => locationNew?.id === locationId
          )
      )
      .map((data) => {
        const bookOnlineUrl = getRelativeParameterizedBookingUrl({
          provider: data,
          config,
          location,
          searchSummary
        });

        return {
          provider: {
            id: data.id,
            contact: data.contacts,
            degrees: data.degrees,
            gender: data.gender,
            image_url: data.image_url,
            name: data.name,
            specialties: data.specialties
          },
          providerReviews: {
            ...data.reviews
          },
          viewProviderUrl: getProviderUrl({
            provider: data,
            location,
            match
          }),
          onViewProvider: onViewProvider,
          onBookAppointment: onBookAppointment,
          bookOnlineUrl
        };
      });
  };

  const providerListWithLocation = providers._result.map((provider) => {
    return {
      ...provider.provider,
      locations: provider.locations
    };
  });
  const providersList = getProvidersForLocation(
    providerListWithLocation,
    selectedLocation.id
  );
  !swipeableDrawerOpen && setSwipeableDrawerOpen(true);
  return (
    <React.Fragment>
      <StyledSwipeableDrawer
        data-testid="BottomSheet"
        handleClose={() => {
          setSwipeableDrawerOpen(false);
          handleClose();
        }}
        isOpen={swipeableDrawerOpen}
        onOpen={onOpen}
      >
        <Box
          sx={{
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center'
          }}
        >
          <DashIcon size="36px" />
        </Box>
        <MapProviderCardListSheetContent>
          <StyledMapProviderCardList
            data-testid={'map-provider-card-list'}
            providers={providersList}
          />
        </MapProviderCardListSheetContent>
      </StyledSwipeableDrawer>
    </React.Fragment>
  );
}
